import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { func, shape, string } from 'prop-types';
import { useCategoryLeaf, useCategoryTree } from '@magento/peregrine/lib/talons/CategoryTree';
import { useStyle } from '@magento/venia-ui/lib/classify';
import Branch from './categoryBranch';
import Leaf from './categoryLeaf';
import defaultClasses from './categoryTree.module.css';
import { Link } from 'react-router-dom';
import { getOutletTagCategory, splitOutletTagCategories } from '../../hooks/utils';

var Tree = function Tree(props) {
  var _data$categories, _data$categories$item, _data$categories$item2, _data$categories2, _treeTitle$props, _treeTitle$props$chil;

  var categoryId = props.categoryId,
      onNavigate = props.onNavigate,
      setCategoryId = props.setCategoryId,
      updateCategories = props.updateCategories,
      isTopLevel = props.isTopLevel;
  var talonProps = useCategoryTree({
    categoryId: categoryId,
    updateCategories: updateCategories
  });

  var _useCategoryLeaf = useCategoryLeaf({
    onNavigate: onNavigate
  }),
      handleClick = _useCategoryLeaf.handleClick;

  var data = talonProps.data,
      childCategories = talonProps.childCategories,
      categoryUrlSuffix = talonProps.categoryUrlSuffix;
  var classes = useStyle(defaultClasses, props.classes); // for each child category, render a direct link if it has no children
  // otherwise render a branch

  var parentName = data === null || data === void 0 ? void 0 : (_data$categories = data.categories) === null || _data$categories === void 0 ? void 0 : (_data$categories$item = _data$categories.items) === null || _data$categories$item === void 0 ? void 0 : (_data$categories$item2 = _data$categories$item[0]) === null || _data$categories$item2 === void 0 ? void 0 : _data$categories$item2.name; // HBF-145: under Outlet, the tag categories (Final Call, Retired Designs, Outlet) come first,
  // with the same names as the Outlet landing page blocks

  var childEntries = Array.from(childCategories || []);

  if (!isTopLevel && (parentName === null || parentName === void 0 ? void 0 : parentName.toLowerCase()) === 'outlet') {
    var _splitOutletTagCatego = splitOutletTagCategories(childEntries, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          category = _ref2[1].category;

      return category;
    }),
        tagCategories = _splitOutletTagCatego.tagCategories,
        otherCategories = _splitOutletTagCatego.otherCategories;

    childEntries = [].concat(_toConsumableArray(tagCategories.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          id = _ref4[0],
          entry = _ref4[1];

      return [id, _objectSpread(_objectSpread({}, entry), {}, {
        category: _objectSpread(_objectSpread({}, entry.category), {}, {
          name: getOutletTagCategory(entry.category).label
        })
      })];
    })), _toConsumableArray(otherCategories));
  }

  var branches = data ? childEntries.map(function (childCategory) {
    var _childCategory = _slicedToArray(childCategory, 2),
        id = _childCategory[0],
        _childCategory$ = _childCategory[1],
        category = _childCategory$.category,
        isLeaf = _childCategory$.isLeaf;

    var item = isLeaf ? React.createElement(Leaf, {
      key: id,
      category: category,
      onNavigate: onNavigate,
      categoryUrlSuffix: categoryUrlSuffix
    }) : React.createElement(Branch, {
      key: id,
      category: category,
      setCategoryId: setCategoryId
    }); // HBF-145: Buy Outlet follows Buy Online in Where To Buy, same as the desktop dropdown

    if (!isTopLevel && (parentName === null || parentName === void 0 ? void 0 : parentName.toLowerCase()) === 'where to buy' && (category === null || category === void 0 ? void 0 : category.name) === 'Buy Online') {
      return [item, React.createElement("li", {
        key: "buy-outlet",
        className: classes.buyOutletRoot
      }, React.createElement(Link, {
        className: classes.buyOutletTarget,
        to: "/outlet",
        onClick: handleClick,
        "aria-label": "Go to Outlet page"
      }, React.createElement("span", {
        className: classes.buyOutletText
      }, "Buy Outlet")))];
    }

    return item;
  }).flat() : null;
  var treeTitle = !isTopLevel ? React.createElement("div", {
    className: classes.treeTitle
  }, data && data.categories && ((_data$categories2 = data.categories) === null || _data$categories2 === void 0 ? void 0 : _data$categories2.items[0].name)) : null;
  return React.createElement("div", {
    className: classes.root
  }, (treeTitle === null || treeTitle === void 0 ? void 0 : (_treeTitle$props = treeTitle.props) === null || _treeTitle$props === void 0 ? void 0 : (_treeTitle$props$chil = _treeTitle$props.children) === null || _treeTitle$props$chil === void 0 ? void 0 : _treeTitle$props$chil.toLowerCase()) === 'outlet' ? React.createElement(Link, {
    to: "/outlet",
    onClick: handleClick
  }, treeTitle) : treeTitle, React.createElement("ul", {
    className: classes.tree
  }, branches));
};

export default Tree;
Tree.propTypes = {
  categoryId: string,
  classes: shape({
    root: string,
    tree: string
  }),
  onNavigate: func.isRequired,
  setCategoryId: func.isRequired,
  updateCategories: func.isRequired
};